module.exports = __webpack_public_path__ + "static/media/product_fix_sel.e306073d.png";